import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
// import { ItemClassDisplayOrderModel } from './model/system-settings.model';
import { ItemDiscountDisplayOrderService } from './item-discount-display-order.service';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { get } from 'jquery';

@Component({
  selector: 'app-item-class-display-order',
  templateUrl: './item-discount-display-order.component.html',
  styleUrl: './item-discount-display-order.component.scss',
  standalone: false
})
export class ItemDiscountDisplayOrderComponent implements OnInit {

  menuList: any[] = []; // Fill this with your API data
  filteredMenuDepartments: any[] = [];
  itemSubClasses: any;
  itemRows: any[] = [];
  dropLists: string[] = []; // hold connected drop list ids
  menuDepartmentControl: FormControl<string | null>;
  itemClassForm!: FormGroup;
  isFormDirty: boolean = false;
  lastConfirmedMenuId: number | null = null;
  menuId: any;
  numberOfColumns: number = 5 + 1; // Default number of columns, can be changed based on requirements
  menuInitialized: boolean = false;
  menuColor: { name: string; value: string; } | undefined;
  sys_repl_ts: string | null = null;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private builder: FormBuilder,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private itemDiscountDisplayOrderService: ItemDiscountDisplayOrderService,
  ) {
    this.itemClassForm = this.builder.group({
      menu_department: this.builder.control('', [Validators.required, this.menuDepartmentValidator]),
      number_of_columns: this.builder.control('')
    });

    this.menuDepartmentControl = this.itemClassForm.get('menu_department') as FormControl;
    this.itemClassForm.valueChanges.subscribe(() => {
      // this.isFormDirty = true;
    });

  }

  /**
   * Component initialization - loads discount display order data
   */
  ngOnInit() {
    this.itemDiscountDisplayOrderList();
  }

  async navBack(): Promise<void> {
    if (this.isFormDirty) {
      const message = "Are you sure you want to discard your changes? Your changes will be lost.";
      const dialogData = new ConfirmDialogModel("Discard unsaved changes?", message);
      const result = await this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: dialogData
      }).afterClosed().toPromise();

      if (result) {
        this.completelyReset();
      }
      // If not confirmed, do nothing
    } else {
      this.completelyReset();
    }
  }

  completelyReset(): void {
    this.itemClassForm.reset();
    this.menuDepartmentControl.setValue('');
    this.filteredMenuDepartments = this.menuList.slice();
    this.menuId = null;
    this.itemDiscountDisplayOrderList(); // Re-fetch from database to revert drag-and-drop changes dynamically
    this.dropLists = [];
    this.menuColor = undefined;
    this.isFormDirty = false;
    this.menuInitialized = false;
  }

  private _filterMenuDepartments(value: string | any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name?.toLowerCase() || '';
    return this.menuList.filter(dept => dept.name.toLowerCase().includes(filterValue));
  }

  displayMenuDepartmentName(dept: any): string {
    return dept && dept.name ? dept.name : '';
  }

  filterMenuDepartments() {
    // Optionally trigger filtering manually if needed
    this.filteredMenuDepartments = this._filterMenuDepartments(this.menuDepartmentControl.value);
  }

  clearMenuDepartment() {
    this.menuDepartmentControl.setValue('');
  }

  menuDepartmentValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null; // Allow empty (optional), or change as needed
    // If value is an object (selected from autocomplete), it's valid
    if (typeof value === 'object' && value.id) return null;
    // If value is a string, check if it matches any sale item name
    const match = this.menuList.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidMenuDepartment: true };
  };

  save() {
    const newData = this.itemSubClasses;
    let requestData = {
      itemDiscountDisplayOrder: newData,
      sys_repl_ts: this.sys_repl_ts
    }

    this.itemDiscountDisplayOrderService.update(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          // handle success
          this.isFormDirty = false;
          let snckBarData: SnackBarData = {
            type: 'success',
            title: 'Saved',
            message: 'The item discount display order has been updated successfully.'
          }
          this.snackBarService.openSnackBar(snckBarData);
          this.itemDiscountDisplayOrderList();
        } else if (response.code === 'DATA_CHANGED_AT_SERVER') {
          let snackBarData: SnackBarData = {
            message: 'This record has been updated by another user. Please reload the data to see the latest changes.',
            title: 'Conflict Detected',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.itemDiscountDisplayOrderList();
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        // handle error
        let snackBarData: SnackBarData = {
          message: 'Failed to update. Connection to the server failed',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  itemDiscountDisplayOrderList() {
    this.itemDiscountDisplayOrderService.getItemClassDisplayOrderByMenuId().subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.itemSubClasses = response.data.discountDisplayOrder;
          this.sys_repl_ts = response.data.sys_repl_ts;

        } else {
          console.error('Failed to load item class display order:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading item class display order:', error);
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.itemSubClasses, event.previousIndex, event.currentIndex);
    this.isFormDirty = true;
    // console.log(this.itemSubClasses);
  }

}